import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  NgbActiveOffcanvas,
  NgbDatepickerModule,
  NgbProgressbarModule,
  NgbTimepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AsideMenuComponent } from './components/aside-menu/aside-menu.component';
import { AvailabilityRecapComponent } from './components/availability-recap/availability-recap.component';
import { ContactFormComponent } from './components/contact-form/contact-form.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { FileInputComponent } from './components/file-input/file-input.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginModalComponent } from './components/login-modal/login-modal.component';
import { PersonalDocumentFormComponent } from './components/personal-document-form/personal-document-form.component';
import { PrivacyModalComponent } from './components/privacy-modal/privacy-modal.component';
import { TimePlannerComponent } from './components/time-planner/time-planner.component';
import { LocationPipe } from './pipes/locations.pipe';
import { NotNullPipe } from './pipes/notnull.pipe';
import { SalaryPipe } from './pipes/salary.pipe';
import { SectorPipe } from './pipes/sectors.pipe';
import { CompanyService } from './services/company.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgbProgressbarModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
  ],
  exports: [
    CommonModule,
    FooterComponent,
    HeaderComponent,
    AsideMenuComponent,
    DatePickerComponent,
    DateRangeComponent,
    ContactFormComponent,
    TimePlannerComponent,
    AvailabilityRecapComponent,
    PrivacyModalComponent,
    FileInputComponent,
    LoginModalComponent,
    PersonalDocumentFormComponent,
    LocationPipe,
    SectorPipe,
    SalaryPipe,
    NotNullPipe,
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    AsideMenuComponent,
    DatePickerComponent,
    DateRangeComponent,
    ContactFormComponent,
    TimePlannerComponent,
    AvailabilityRecapComponent,
    PrivacyModalComponent,
    FileInputComponent,
    LoginModalComponent,
    PersonalDocumentFormComponent,
    LocationPipe,
    SectorPipe,
    SalaryPipe,
    NotNullPipe,
  ],
  providers: [NgbActiveOffcanvas, CompanyService],
})
export class CommonSharedModule {}
